<template>
  <v-layout>
    <div class="py-14 sm:pt-20 sm:pb-36">
      <div class="container max-w-lg">
        <h1 class="title-1 mb-8 text-center">
          Update account
        </h1>

        <div class="card mb-6">
          <v-form
            :data="form"
            :url="$laravel.route('api.users.account.update_password')"
            method="patch"
            @success="onSuccess($event)"
          >
            <v-input
              v-model="form.old_password"
              type="password"
              name="old_password"
              label="Old password"
              class="mb-5"
              input-class="w-full"
            />

            <v-input
              v-model="form.new_password"
              type="password"
              name="new_password"
              label="New password"
              class="mb-5"
              input-class="w-full"
            />

            <v-input
              v-model="form.new_password_confirmation"
              type="password"
              name="new_password_confirmation"
              label="New password confirmation"
              class="mb-5"
              input-class="w-full"
            />

            <button
              type="submit"
              class="btn btn-primary w-full mt-6"
            >
              Update my password
            </button>
          </v-form>
        </div>

        <button
          class="btn btn-white w-full"
          @click="$logout()"
        >
          Logout
        </button>
      </div>
    </div>
  </v-layout>
</template>
<script>
export default {
  name: "v-account",
  data() {
    return {
      form: {
        old_password: "",
        new_password: "",
        new_password_confirmation: ""
      }
    };
  },
  methods: {
    onSuccess(response) {
      this.$notificator.success(response.data.message);
      this.$router.push("/");
    }
  }
};
</script>
